import { inject, Injectable } from '@angular/core';
import {
  KpiService,
  LayoutService,
  SubjectAreaService,
} from '@shared/services';
import { DashboardNavigationInfo } from '../models/analytic.model';

@Injectable({ providedIn: 'root' })
export class DashboardNavigationInfoService {
  private readonly subjectAreaService = inject(SubjectAreaService);
  private readonly layoutService = inject(LayoutService);
  private readonly kpiService = inject(KpiService);

  public getNavigationInfo(): DashboardNavigationInfo {
    const dashboardNavigationInfo: DashboardNavigationInfo = {};
    if (this.subjectAreaService.activeSubjectArea) {
      ((dashboardNavigationInfo.subjectAreaId =
        this.subjectAreaService.activeSubjectArea.subjectAreaId),
        (dashboardNavigationInfo.subjectAreaName =
          this.subjectAreaService.activeSubjectArea.subjectAreaName));
    }

    if (this.layoutService.activeLayout) {
      dashboardNavigationInfo.layoutId =
        this.layoutService.activeLayout.layoutId;
      dashboardNavigationInfo.layoutName =
        this.layoutService.activeLayout.layoutName;
    }

    if (this.kpiService.activeKpi) {
      dashboardNavigationInfo.kpiId = this.kpiService.activeKpi.kpiId;
      dashboardNavigationInfo.kpiName = this.kpiService.activeKpi.name;
    }
    return dashboardNavigationInfo;
  }
}
